import ComponentsCollection from '../../../general/js/components-collection';
import NavItem from './nav-item.component';
import BaseComponent from '../../../general/js/base-component';
import {EVENT_OUTER_CLICK} from './header-events';
import eventBus from '../../../general/js/event-bus';
import app, {EVENT_DEVICE_TYPE_CHANGED, DEVICE_TYPE_DESKTOP} from "../../../general/js/app";

export default class NavComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.triggers = this.props.triggers;
        this.currentItem = null;
        this.onHeaderOuterClick = this.onHeaderOuterClick.bind(this);
        this.onDeviceTypeChanged = this.onDeviceTypeChanged.bind(this);
        this.init();
    }

    init() {

        this.navItems = ComponentsCollection.getInstance().createComponents(this.element, 'nav-item', NavItem, {
            onToggle: this.onToggle.bind(this),
            triggers: this.triggers
        });

        eventBus.addListener(EVENT_OUTER_CLICK, this.onHeaderOuterClick);
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged(oldType, newType) {
        //switch from tablet/mobile to desktop
        //we have to close burger menu properly
        if (newType == DEVICE_TYPE_DESKTOP || oldType == DEVICE_TYPE_DESKTOP) {
            this.resetMenu();
        }
    }

    //callback for all nav-item children
    //when another nav item start to open - we have to close previously opened nav item
    onToggle(component) {
        if (this.currentItem) {
            this.currentItem.close().then(() => {
                //if we have closed the same nav-item
                //just set current to null
                if (this.currentItem === component) {
                    this.currentItem = null;
                } else {
                    //otherwise we open new one
                    this.currentItem = component;
                    this.currentItem.open();
                }
            });
        } else {
            this.currentItem = component;
            this.currentItem.open();
        }
    }

    onHeaderOuterClick() {
        if (this.currentItem) {
            this.currentItem.close();
            this.currentItem = null;
        }
    }

    //resolve immediately or wait until current item finish it's close transition
    reset() {
        if (this.currentItem) {
            return this.currentItem.close().then(() => {
                this.currentItem = null;
            })
        } else {
            return Promise.resolve();
        }
    }

    resetMenu() {
        this.navItems.forEach(navItem => navItem.reset());
        this.currentItem = null;
    }
}



// WEBPACK FOOTER //
// ./app/components/header/js/nav.component.js